import { EmploymentType } from 'types/types';
import invert from 'lodash/invert';

export const ftPtToEmploymentType: Record<string, EmploymentType> = {
  'Full-Time': EmploymentType.FullTime,
  'Part-Time': EmploymentType.PartTime,
};

export const employmentTypeToFtPt = invert(ftPtToEmploymentType);
